import LocalizedStrings from "react-localization";

let headerStrings = new LocalizedStrings({
    en: {
        contact: "CONTACT US",
        library: "LIBRARY",
        studios: "STUDIOS",
        players: "PLAYERS",
        home: "HOME",
        menu: "MENU",
        signIn: "SIGN IN",
        subscription: "SUBSCRIPTION",
        downloads: "DOWNLOADS",
        signOut: "SIGN OUT",

    },
});

export default headerStrings;